import { PageViewProps } from 'common/hooks';
import { Language } from './cookies-types';

/**
 * Возвращает объект с данными для отправки в событии "GA:pageview"
 * @param {Record<string, string>} cookie
 * @returns {PageViewProps}
 */
export const selectPageViewData = (cookie: Record<string, string>): PageViewProps => ({
  userId: cookie.customerId || null,
  userAuth: cookie['user-auth'] ? 1 : 0,
});

export const getLang = (cookie: Record<string, string>): Language => cookie?.lang as Language ?? 'ru';
